@if (_isVisible) {
  <div>
    <input (change)="onClick($event)" name="switch" type="checkbox" [checked]="isChecked"
           [attr.aria-label]="params?.ariaLabel || params?.colDef?.headerName">
  </div>
}